import { Component, OnInit,ViewChild,AfterViewInit } from '@angular/core';
import { FrontOffService,MasterService } from '../../services/index';

import { AppGlobals } from '../../shared/app.global';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';
@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.scss'],
  providers:[FrontOffService,AppGlobals,MasterService]
})
export class EnquiryComponent implements OnInit {
  bookdetails:any[];
  depts:any[];
  catgories:any[];
  suppliers:any[];
  publishers:any[];
  sources:any[];
  subjects:any[];
  arrcourse=[]

 
  acctypes: any[];
  @ViewChild('dt') table: any;
  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  objstudent:any={};
  dashcount:any={};
  stuadm:any={};
  oprtype:string;
  filtcatgory:any[];
  bindtypes:any[];
  laguages:any[];
  currency:any[];
  //=[{'id':'1','name':'English'},{'id':'2','name':'Hindi'}];
  tab=1;
  selcat:any=0;
  verifiedstatus:any;
  arrmoe:any=[];
  //[{value:'Walkin',name:'Walkin'},{value:'Telephone',name:'Telephone'},{value:'Online',name:'Online'}];
  genders:any=[{value:'Male',name:'Male'},{value:'Female',name:'Female'},{value:'Trans',name:'Trans'}];
  stustatuses:any=[{value:'Active',name:'Active'},{value:'Inactive',name:'Inactive'}];
  statuses:any=[];
  //[{value:'Enquired',name:'Enquired'},{value:'Enrolled',name:'Enrolled'}
  //,{value:'Eligible',name:'Eligible'},{value:'Test Done',name:'Test Done'}
  //,{value:'Selected',name:'Selected'},{value:'Not Selected',name:'Not Selected'},{value:'Not Interested',name:'Not Interested'}];
  //modalOption: NgbModalOptions = {};
  //filteredOptions: Observable<any[]>;


  classes:any=[];
  sections:any=[];
  bloodgp:any=[];
  castecats:any=[];
  subcomb:any=[];
 
  arhouse:any=[];
  aylist:any[];
  arpayopt:any=[];
  arfeequota:any=[];
  armot:any=[];
  arrmtongue:any=[];
  infocnt:any={};
  arrclass:any=[];
showchart:Boolean=false;
showchart1:Boolean=false;

  barChartOptions: ChartOptions = {
    responsive: true,
  };
  barChartLabels: Label[] = [];

  weekdaychartlbs: Label[] = [];
  barChartType: ChartType = 'bar';
  barChartLegend = true;
  barChartPlugins = [];
  barChartColors: Color[] = [
    {
      
      backgroundColor: '#FF00CC',
    },
    {
     
      backgroundColor: '#0033FF',
    },
  ];
  monthlydata: ChartDataSets[] = [
    
  ];

  weekdaydata: ChartDataSets[] = [
    
  ];
  clcd: string;

 
  constructor(private http: HttpClient,private mservice:MasterService, private fservice: FrontOffService,private modalService: NgbModal,private apglobal:AppGlobals) {

  
   }

 

 
   _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9\+\-\ ]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
    

  ngOnInit(): void {
    this.clcd=localStorage.getItem('clcd');
   this.enqoverview();
    this.getenquirydetails();
    this.getenquiryinfocnt();
    this.masgeneral('enquiry');
    this.masgeneral('enquiry mode');
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'xl'
      }
    

  }

 
masbloodgroup() {
  this.fservice.masbloodgroups()
      .subscribe(
      resultArray => {
          console.log('bloodgp', resultArray);
          this.bloodgp = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

mascastecat() {
  debugger
  this.fservice.mascastecat()
      .subscribe(
      resultArray => {
          console.log('castecats', resultArray);
          this.castecats = resultArray.filter(item => item.active==='Yes')
         
      },
      error => console.log("Error :: " + error)
      )
}


massubcomb() {
  this.fservice.massubcomb()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.subcomb = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


masacademicyears() {
  this.fservice.masacademicyear()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.aylist = resultArray;

          //this.aylist.sort((a, b) => parseInt(a.ayid).localeCompare(parseInt(b.ayid))
          this.aylist.sort((a, b) => {
            return parseInt(b.ayid)-parseInt(a.ayid);
          });
         
      },
      error => console.log("Error :: " + error)
      )
}
masclass() {
  this.fservice.masclass()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.classes = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

masmtongue() {
  this.mservice.getmasmtongue()
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          this.arrmtongue = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


masgeneral(tag) {
  this.mservice.masgeneral(tag)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          if (tag=='enquiry')
          {
          this.statuses = resultArray;
          }

          else if (tag=='enquiry mode')
          {
          this.arrmoe = resultArray;
          }
         
      },
      error => console.log("Error :: " + error)
      )
}

mascourse() {
  this.mservice.mascourse()
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          this.arrcourse = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}
massection() {
  this.fservice.massection()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.sections = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

mashouse() {
  this.fservice.mashouse()
      .subscribe(
      resultArray => {
          console.log('arhouse', resultArray);
          this.arhouse = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}

masfeequota() {
  this.fservice.masfeequota()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arfeequota = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}
maspayopts() {
  this.fservice.maspayopt()
      .subscribe(
      resultArray => {
          console.log('maspayopt', resultArray);
          this.arpayopt = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}



masmot() {
  this.fservice.masmot()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.armot = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}
  admdialog(enqdata:any,cmd:string,content)
  {

  console.log('enqdata',enqdata);
  this.masclass();
    this.massection();
    this.masbloodgroup();
    this.mascastecat();
    this.massubcomb();
    this.masacademicyears();
    this.mashouse();
    this.maspayopts();
    this.masfeequota();
    this.masmot();
    this.masmtongue();
    this.mascourse();
  //{"enid":"2","ayid":"1","endt":"2018-03-06T13:00:00.000Z","name":"teststudent","dob":{"validator":null,"asyncValidator":null,"pristine":true,"touched":false,"_onDisabledChange":[],"_onChange":[],"_pendingValue":null,"value":null,"status":"VALID","errors":null,"valueChanges":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null,"__isAsync":false},"statusChanges":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null,"__isAsync":false}},"gender":"M","clid":"42","preinstitute":"sdsdsds","inplace":"agadi collage","preacscore":"60","fatname":"aa","fatedu":"xcxcx","fatprof":"xcxcx","fatmobile":"1212121211","fatemail":"wewewe@fg.com","motname":"xcxcx","motedu":"xcxcxc","motprof":"xcxc","motmobile":"1212121256","motemail":"rest@123.c","gardname":"xcxcx","gardrelation":"xxcxc","gardmobile":"2334344545","mothertoungue":"kannada","address":"sdsdsdsdsd","caste":"caste","refname":"gfgfgf","refmobile":"1222222222","enstatus":"Enquired","enremarks":"asdasdd","linedt":"2018-03-13 17:47:19","oprtag":"insert","dbnm":"mycplvdev"}
  //let fdob=new FormControl(new Date(enqdata.dob));
  //let fdoa=new FormControl(new Date(enqdata.endt));
  debugger
 /*this.stuadm.name=enqdata.stunm;
 this.stuadm.dob1=enqdata.dob;
 this.stuadm.caste='';
 this.stuadm.gender=enqdata.gender;
 this.stuadm.fatname=enqdata.parnm;
 this.stuadm.fatprofession='';
 this.stuadm.fatmobile=enqdata.parmobile
 this.stuadm.fatemail=enqdata.paremail;
 this.stuadm.motname=enqdata.parnm;
 this.stuadm.motprofession='';
 this.stuadm.motmobile='';
 this.stuadm.motemail='';
 this.stuadm.admclid=enqdata.eclid;
 this.stuadm.clid=enqdata.eclid;
 this.stuadm.address=enqdata.address;
 this.stuadm.mothertongue='';
 this.stuadm.stuId=0;
 this.stuadm.adayid=1;
 this.stuadm.doa1=this.apglobal.getdatetoday();
 this.stuadm.admno='';
 this.stuadm.bloodgroup=this.bloodgp[0].bgid;
 this.stuadm.nationality='Indian';
 this.stuadm.religion='';
 this.stuadm.subcaste='';
 this.stuadm.aadharno='';
 this.stuadm.category=enqdata.catid;
 this.stuadm.stustatush='Active';
 this.stuadm.enqid=enqdata.enid;
 this.stuadm.stsno='';
 this.stuadm.rollno='';
 this.stuadm.city='';
 this.stuadm.state='Karnataka';
 this.stuadm.pincode='';
 this.stuadm.feqid=0;
 this.stuadm.payoptid=0;
 
 
 this.stuadm.rootno='';
 this.stuadm.locdist='';
 this.stuadm.secid=1;
 this.stuadm.country='India';
 this.stuadm.house='';

 this.stuadm.secid=this.sections[0].secid;
 this.stuadm.stsno=0;
 this.stuadm.subcombid=this.subcomb[0].sucbid;

 this.stuadm.feqid=this.arfeequota[0].feqtId;
 this.stuadm.payoptid='1';
 this.stuadm.payopttranid='1';
 this.stuadm.mot=this.armot[0].mot;
  
 this.stuadm.oprtag='insert';
 this.stuadm.dbnm='db';*/
 this.stuadm.stuid=0;
    this.stuadm.stunm=enqdata.stunm;
    this.stuadm.ayid=this.aylist[0].ayid;
    
   
    this.stuadm.dob=enqdata.dob;
    this.stuadm.gender=enqdata.gender;
    this.stuadm.bgid='1';
    this.stuadm.mtid=enqdata.mtid;
    this.stuadm.pob='';
    this.stuadm.nationality='Indian';
    this.stuadm.religion='.';
    this.stuadm.caste='.';
    this.stuadm.subcaste='.';
    this.stuadm.stumobile=enqdata.stumobile;
    this.stuadm.stuemail=enqdata.stuemail;
    this.stuadm.fatnm=enqdata.parnm;
    this.stuadm.fatemail=enqdata.paremail;
    this.stuadm.fatprof='';
    this.stuadm.fatedu='';
    this.stuadm.fatmobile=enqdata.parmobile;
    this.stuadm.motemail='';
    this.stuadm.motmobile='';
    this.stuadm.motnm='';
    this.stuadm.motprof='';
    this.stuadm.motedu='';


    
    this.stuadm.address=enqdata.address;
    this.stuadm.city=enqdata.city;
    this.stuadm.pin=enqdata.pin;
    this.stuadm.latitude='';
    this.stuadm.logitude='';
    this.stuadm.state='';
    this.stuadm.country='India';

    this.stuadm.addt=this.fservice.getdatetoday();
    this.stuadm.vldt=this.fservice.getdatetoday();
    this.stuadm.feqtid=this.arfeequota[0].feqtId;
    this.stuadm.adayid=this.aylist[0].ayid;
    this.stuadm.payoptid='1';
    this.stuadm.payopttranid='1';
    this.stuadm.aadhaar='';
    
    this.stuadm.catid=enqdata.catid;
    this.stuadm.adclid=enqdata.eclid;
    this.stuadm.clid=enqdata.eclid;
    this.stuadm.scid=this.sections[0].scid;
    this.stuadm.regno=0;
    this.stuadm.sucbid=this.subcomb[0].sucbid;
    this.stuadm.rollno='0';
    this.stuadm.hsid='0';
    this.stuadm.crid='1';
    this.stuadm.usid='';

    this.stuadm.tpreq='No';
    this.stuadm.payoptidtp='0';
    this.stuadm.feqtidtp='0';
    this.stuadm.htreq='No';
    this.stuadm.payoptidht='0';
    this.stuadm.feqtidht='0';

    this.stuadm.penno='';
 this.stuadm.enid=enqdata.enid;
    this.stuadm.stustatus='Active';
    this.stuadm.oprtype='insert';
  console.log('admdata',JSON.stringify( this.stuadm));

  this.modalRef=this.modalService.open(content,this.modalOptions);
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'xl'
    }
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
  }
  openbookdialog(content,formdata,cmd) {
    console.log("formdata",formdata);
    this.mascastecat();
    this.masmtongue();
    this.masclass();
    this.mascourse();

  
    this.oprtype=cmd;
    if(cmd=='insert')
    {
       this.objstudent={};
       this.objstudent.enid=0;
       
     
       this.objstudent.endt=this.fservice.getdatetoday();
       this.objstudent.stunm='';
       this.objstudent.dob=this.fservice.getdatetoday();
       this.objstudent.gender='Male';
       
       this.objstudent.qclid='0';
       this.objstudent.qcrid='0';
       this.objstudent.qyop='';
       this.objstudent.mtid='0';
       this.objstudent.qinnm='';
       this.objstudent.qgrade='';
       this.objstudent.qpct='';
       this.objstudent.ecrid='0';
       this.objstudent.eclid='0';
       this.objstudent.catid='0';
       this.objstudent.parnm='';
       this.objstudent.parmobile='';
       this.objstudent.paremail='';
      
       this.objstudent.motedu='';
       this.objstudent.stumobile='';
       this.objstudent.stuemail='';
       this.objstudent.preacscore='';
      
       this.objstudent.city='';
       this.objstudent.pin='';
      //  this.objstudent.state='';
      //  this.objstudent.country='India';
       this.objstudent.address='';
       
       this.objstudent.enstatus='Enquired';
      
       this.objstudent.ennote='';
       this.objstudent.oprtype=cmd;
      
       this.objstudent.moe='Walkin';
      
  
      
      
    }
    else if (cmd=='update')
    {
      //this.getstudentdata('selbystuid',formdata)
      this.objstudent=formdata;
      this.objstudent.oprtype=cmd;
  
    }
    console.log("objstudent",this.objstudent);
   // this.objstudent.enqid=0;
    this.modalRef=this.modalService.open(content,this.modalOptions);
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'xl'
      }
     this.modalRef.result.then((result) => {
    
          // this.Asmtdetls(asid);
           this.closeResult = `Closed with: ${result}`;
       }, (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
       });
      
    
  }
  
  Saveenquiry()
{
  debugger;

 
  console.log(JSON.stringify(this.objstudent));
  

  this.fservice.save_stutenquiry(this.objstudent)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      //this.alertmessage=result.message;
  if (result.status=='Success')
  {

    let localmodref=this.modalRef;
              localmodref.close();
 this.getenquirydetails();
  }
  }, error => 
  alert('error in connection')
  //this.alertmessage='error in connection'
  );

}
  
enqoverview() {
  this.fservice.enqoverview()
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          if(resultArray.arrmonth != undefined)
          {
        this.arrclass= resultArray.arrclass;
          var arr = [];
    var issued = [];
    var returned = [];
    for ( var i = 0; i < resultArray.arrmonth.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
            arr.push(resultArray.arrmonth[i].name);
            issued.push(parseInt( resultArray.arrmonth[i].encnt)); // 
            returned.push(parseInt( resultArray.arrmonth[i].ccnt));
            
           
    }
   
   this.monthlydata = [
      { data: issued, label: 'Enquired', 
     },
      { data: returned, label: 'Admitted',
       },
    ];
     this.barChartLabels = arr;
     this.showchart=true;

  }
else{

  this.monthlydata=null;
  this.showchart=false;
}
  if(resultArray.arrday != undefined)
          {
     var arr1 = [];
    var issued1 = [];
    var returned1 = [];
    for ( var i = 0; i < resultArray.arrday.length ; i++) {
      //console.log('multiarray -i',JSON.stringify(i));
       
            
            arr1.push(resultArray.arrday[i].name);
            issued1.push(parseInt( resultArray.arrday[i].encnt)); // 
            returned1.push(parseInt( resultArray.arrday[i].ccnt));
            
           
    }
   
   this.weekdaydata = [
      { data: issued1, label: 'Enquired', 
     },
      { data: returned1, label: 'Admitted',
       },
    ];
     this.weekdaychartlbs = arr1;
     this.showchart1=true;
  }
    
  else{

    this.weekdaydata=null;
    this.showchart1=false;
  }
      },
      error => console.log("Error :: " + error)
      )
}
// Saveadmissioninfo()
// {
//   debugger;
//   let clcd=localStorage.getItem('clcd');
//   let aycd=localStorage.getItem('aycd');
 
//   console.log(JSON.stringify(this.stuadm));
  

//   this.fservice.save_admission(this.stuadm)
//   .subscribe(result => {
//       console.log('ret',JSON.stringify(result));
//       alert (result.message);
//       //this.alertmessage=result.message;
  
//  // this.Getclasslist();
//   }, error => 
//   alert('error in connection')
//   //this.alertmessage='error in connection'
//   );

// }


Saveadmissioninfo(objstudent)
{
  debugger;
  let clcd=localStorage.getItem('clcd');
  let aycd=localStorage.getItem('aycd');
 
  console.log(JSON.stringify(objstudent));
  

  this.fservice.save_admission(objstudent)
  .subscribe(result => {
      console.log('ret',JSON.stringify(result));
      alert (result.message);
      if(result.status=='Success')
{
  let localmodref=this.modalRef;
localmodref.close();
this.getenquirydetails();

}
      //this.alertmessage=result.message;
  
 // this.Getclasslist();
  }, error => 
  alert('error in connection')

  
  //this.alertmessage='error in connection'
  );

}
 
  getenquirydetails() {
    this.fservice.getstutenquiry()
        .subscribe(
        resultArray => {
            console.log('books-result', resultArray);
            this.bookdetails = resultArray;
           // this.authorfilter();
          //   this.author  = resultArray [
          //     {'author'}
          // ];
        },
        error => console.log("Error :: " + error)
        )
}

getenquiryinfocnt() {
  this.fservice.getenquiryinfocnt()
      .subscribe(
      resultArray => {
          console.log('books-result', resultArray);
          this.infocnt = resultArray;
         // this.authorfilter();
        //   this.author  = resultArray [
        //     {'author'}
        // ];
      },
      error => console.log("Error :: " + error)
      )
}


}

